import Vue from 'vue'
import VueRouter from 'vue-router'
import TheLayoutBase from '@comp/TheLayoutBase.vue'
Vue.use(VueRouter)

// 静态路由，不需要区分用户权限的
export const routes = [
  {
    path: '/',
    component: TheLayoutBase,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'index',
        component: () => import('@/views/Index.vue')
      },
      // {
      //   path: 'yyjh',
      //   name: 'yyjh',
      //   component: () => import('@/views/Yiyang.vue')
      // }
    ]
  },
  {
    path: '/',
    component: TheLayoutBase,
    redirect: '/yyjh',
    children: [
      {
        path: 'yyjh',
        name: 'yyjh',
        component: () => import('@/views/Yiyang.vue')
      }
    ]
  },
  {
    path: '/m',
    component: () => import('@comp/TheLayoutMobile'),
    redirect: '/m/index',
    children: [
      {
        path: 'index',
        name: 'mobile-index',
        component: () => import('@/views/Mobile/Index'),
        meta: {
          mobile: true
        }
      },
      // {
      //   path: 'yyjh',
      //   name: 'mobile-yyjh',
      //   component: () => import('@/views/Mobile/Yiyang'),
      //   meta: {
      //     mobile: true
      //   }
      // }
    ]
  },
  {
    path: '/m',
    component: () => import('@comp/TheLayoutMobile'),
    redirect: '/m/yyjh',
    children: [
      {
        path: 'yyjh',
        name: 'mobile-yyjh',
        component: () => import('@/views/Mobile/Yiyang'),
        meta: {
          mobile: true
        }
      }
    ]
  },
  {
    path: '/redirect',
    component: TheLayoutBase,
    children: [
      {
        path: ':path(.*)',
        name: 'redirect',
        component: () => import('@/views/Redirect.vue')
      }
    ]
  },
  {
    path: '*',
    component: () => import('@/views/Error/404.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  //判断用户哪个终端打开
  const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  if (to.meta.mobile && !isMobile) {
    // 访问mobile页面但设备信息不是移动端，跳转至PC页面
    if(to.path=='/m/yyjh'){
      next('/yyjh')
    }else{
      next('/index')
    }
  } else if (!to.meta.mobile && isMobile) {
    if(to.path=='/yyjh'){
      next('/m/yyjh')
    }else{
      next('/m/index')
    }
  } else {
    next()
  }
})
export default router
